<template>
	<!-- @size-change="handleSizeChange" -->
	<!-- <div class="pagesbox" > -->
		<!-- <span class="demonstration">直接前往</span> -->
		<el-pagination 
			v-if="pageTotal!=0"
			small
			hide-on-single-page
			@current-change="handleCurrentChange"
			:current-page.sync="currentPage"
			:page-size="pageSize"
			layout="prev, pager, next, jumper"
			:total="pageTotal">
		</el-pagination>
<!-- 	</div> -->
</template>


<script>
	export default {
		name:'Pages',
		props: {
			// pageSize: Number,
			pageTotal:Number,
			pageSize:Number,
		},
		methods: {
			// handleSizeChange(val) {
			// 	console.log('每页 ${val} 条');
			// },
			handleCurrentChange(val) {
				window.console.log('当前页:',val);
				this.$emit('ChangePage',val);  
			}
		},
		data() {
			return {
				currentPage: 1,
			};
		}
	}
</script>

<style>
	.el-pagination{
		width: 33%;
		/* height: 100%; */
		height: 25px;
		/* margin-right:8px; */
		right:8px;
		line-height: 30px;
		/* border:1px solid #185c9c; */
		margin-top:auto;
		margin-bottom: auto;
		/* float: right; */
	}
	.pagesbox{
		/* width:30%; */
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items:center;
		justify-content: center;
		color: #fff;
		/* margin:0%; */
		padding: 0%;
		/* border:1px solid #185c9c; */
		
	}
</style>
